module.exports = __webpack_public_path__ + "img/06_BetonsarkophagRost_iPad_P.292c860e.jpg";